import { ACQUISITION_MODE_OPTIONS, APP_SETTINGS } from "./acquisitionConstants";

const InfoField = ({ label, value }) => (
  <div className="info-field">
    <span className="info-field_label">{label}</span>
    <span className="info-field_value">{value || "-"}</span>
  </div>
);

// Read-only counterpart of AcquisitionSettingsFields.
const AcquisitionSettingsInfo = ({ formData, showDivider = true }) => {
  const acquisitionModeLabel = ACQUISITION_MODE_OPTIONS.find(
    (option) => String(option.value) === String(formData.dataAcquisitionMode)
  )?.label;

  const isIntermittent = !!formData.isIntermittentCollection;
  const isOffline = formData.dataMode === "offline";
  const dataModeLabel = isOffline ? "Offline" : "Online";

  return (
    <>
      {showDivider && (
        <div className="patient-info-grid_divider">
          <h4>Data Acquisition Settings</h4>
        </div>
      )}
      <InfoField label="Data Mode" value={dataModeLabel} />
      <InfoField label="Data Acquisition Mode" value={acquisitionModeLabel} />

      {/* INTERMITTENT COLLECTION ONLY APPLIES IN OFFLINE MODE */}
      {isOffline && (
        <>
          <InfoField
            label="Intermittent Collection"
            value={isIntermittent ? "Enabled" : "Disabled"}
          />

          {isIntermittent && (
            <>
              <InfoField
                label="Active Time"
                value={formData.activeTime ? `${formData.activeTime} min` : "-"}
              />
              <InfoField
                label="Sleep Time"
                value={formData.sleepTime ? `${formData.sleepTime} min` : "-"}
              />
            </>
          )}
        </>
      )}

      {/* APP SETTINGS ONLY APPLY IN ONLINE MODE */}
      {!isOffline &&
        APP_SETTINGS.map(({ name, label }) => (
          <InfoField key={name} label={label} value={formData[name] ? "Yes" : "No"} />
        ))}
    </>
  );
};

export default AcquisitionSettingsInfo;
